// src/components/UI/components/DropdownMenu/DropdownMenuContent.tsx

import { Content, Portal } from '@radix-ui/react-dropdown-menu';
import { forwardRef } from 'react';
import { cx } from '../../lib/utils';

const DropdownMenuContent = forwardRef<
  React.ElementRef<typeof Content>,
  React.ComponentPropsWithoutRef<typeof Content>
>(
  (
    {
      className,
      sideOffset = 8,
      collisionPadding = 8,
      align = 'center',
      loop = true,
      ...props
    },
    forwardedRef,
  ) => (
    <Portal>
      <Content
        ref={forwardedRef}
        className={cx(
          // base
          'relative z-50 overflow-hidden rounded-md border p-1 shadow-xl shadow-black/[2.5%]',
          // widths
          'min-w-48',
          // heights
          'max-h-[var(--radix-popper-available-height)]',
          // background color
          'bg-white dark:bg-[#090E1A]',
          // text color
          'text-gray-900 dark:text-gray-50',
          // border color
          'border-gray-200 dark:border-gray-800',
          // transition
          'will-change-[transform,opacity]',
          'data-[state=closed]:animate-hide',
          'data-[side=bottom]:animate-slideDownAndFade data-[side=left]:animate-slideLeftAndFade data-[side=right]:animate-slideRightAndFade data-[side=top]:animate-slideUpAndFade',
          className,
        )}
        sideOffset={sideOffset}
        align={align}
        collisionPadding={collisionPadding}
        loop={loop}
        {...props}
      />
    </Portal>
  ),
);
DropdownMenuContent.displayName = 'DropdownMenuContent';

export { DropdownMenuContent };
